import { useState } from "react"
import { string, bool } from "prop-types"
import axios from "axios"
import pcoUrl from "pco-url"
import { Box, Text, Radio, Link } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import { Modal, useModal } from "../modals/Modal"

const ChurchCenterSettingsModal = ({
  ccPublishingEnabled,
  ccEnabled,
  churchCenterEventSort: churchCenterEventSortFromProps
}) => {
  const [churchCenterEventSort, setChurchCenterEventSort] = useState(churchCenterEventSortFromProps)
  const { onModalClose, onSaving } = useModal()

  const handleSaveClick = () => {
    onSaving()
    axios
      .post(
        `${pcoUrl(railsEnv)("api")}/registrations/v2/change_ccw_sort`,
        {
          church_center_sort_order: churchCenterEventSort
        },
        {
          withCredentials: true,
          headers: {
            "X-CSRF-Token": $.rails.csrfToken()
          }
        }
      )
      .then(_ => onModalClose())
  }

  const handleCancelClick = () => {
    setChurchCenterEventSort(churchCenterEventSortFromProps)
    onModalClose()
  }

  return (
    <Modal
      title="Church Center Settings"
      onModalSubmit={handleSaveClick}
      onModalCancel={handleCancelClick}
      showSubmitButton={ccEnabled}
    >
      <Box color={colors.neutral_700}>
        {ccEnabled ? (
          <>
            <Text weight={700} marginBottom={0.5}>
              Signup sorting
            </Text>
            <Text marginBottom={2}>
              On Church Center, featured signups appear on top. All other signups are sorted:
            </Text>
            {[
              { label: "By date, with undated on top", value: "dateless_first" },
              { label: "By date, with undated on bottom", value: "dateless_last" },
              { label: "Alphabetically by title", value: "alpha" }
            ].map(option => (
              <Radio
                checked={option.value == churchCenterEventSort}
                key={option.value}
                size="lg"
                marginBottom={1}
                label={
                  <Text marginLeft={0.5} size={3}>
                    {option.label}
                  </Text>
                }
                onChange={() => setChurchCenterEventSort(option.value)}
              />
            ))}
          </>
        ) : (
          <>
            <Text marginBottom={3}>
              Registrations is not published on Church Center. People cannot register or browse
              signups on the web or mobile app.
            </Text>
            <ManageCCButton ccPublishingEnabled={ccPublishingEnabled} />
          </>
        )}
      </Box>
    </Modal>
  )
}

ChurchCenterSettingsModal.propTypes = {
  churchCenterEventSort: string,
  ccEnabled: bool,
  ccPublishingEnabled: bool
}

const ManageCCButton = ({ ccPublishingEnabled }) => {
  const linkPath = ccPublishingEnabled
    ? `${pcoUrl(window.railsEnv)("publishing")}/pages/built-in-editor/registrations`
    : `${pcoUrl(window.railsEnv)("accounts")}/organization?tab=church_center`

  const buttonTitle = ccPublishingEnabled ? "Manage in Publishing" : "Manage in Account Settings"
  return (
    <Link to={linkPath} external>
      {buttonTitle}
    </Link>
  )
}

ManageCCButton.propTypes = {
  ccPublishingEnabled: bool
}

export default ChurchCenterSettingsModal
